/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { FaEdit } from "react-icons/fa";
import { MdDeleteSweep } from "react-icons/md";
import { Flex, Heading, Button } from "@chakra-ui/react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import FormInput from "../../../components/forms/form-Input";
import {
  useLookupRegions,
  useLookupRoutesRegion,
} from "../../../services/lookups-mutations";
import { escalationGroupDefault } from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";

export default function EscalationGroups({
  onPrevStep,
  onNextStep,
  escalationGroups,
  addData,
}) {
  const [currentEditing, setCurrentEditing] = useState(null);
  const [currentEditingApp, setCurrentEditingApp] = useState(null);
  const [currentEditingEmail, setCurrentEditingEmail] = useState(null);
  const [currentEditingCall, setCurrentEditingCall] = useState(null);
  const [regions, setRegions] = useState([]);
  const {
    mutate: getRegions,
    data: regionsList,

    reset: resetRegionsList,
  } = useLookupRegions();
  const {
    mutate: getRoutes,
    data: routesList,

    reset: resetRoutes,
  } = useLookupRoutesRegion();

  useEffect(() => {
    if (regionsList) {
      setRegions(
        regionsList.data.map((elm) => ({ value: elm.name, label: elm.name }))
      );
      resetRegionsList();
    }
  }, [regionsList]);
  useEffect(() => {
    getRegions("UAE");
  }, []);
  const {
    handleSubmit,
    control,
    reset,
    resetField,
    setValue,
    getValues,
    setError,
    watch,
    clearErrors,
    formState: { errors },
  } = useForm({
    defaultValues: {
      ...escalationGroupDefault,
      escalationGroups: [...escalationGroups],
    },
  });
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    region: { required: "Please select region" },
    routeNo: { required: "Please select route" },
    escalationLevel: {
      required: "Please add escalation level",
      validate: (value) => {
        if (value > 4 || value < 1) return "Please add valid escalation level";
      },
    },
  };
  const {
    fields: escalationGroupsFields,
    remove: escalationGroupsRemove,
    // update: escalationGroupsUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "escalationGroups",
  });

  const {
    fields: inAppRecipientsFields,
    append: inAppRecipientsAppend,
    remove: inAppRecipientsRemove,
    update: inAppRecipientsUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "inAppRecipients",
  });
  const {
    fields: emailRecipientsFields,
    append: emailRecipientsAppend,
    remove: emailRecipientsRemove,
    update: emailRecipientsUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "emailRecipients",
  });
  const {
    fields: callRecipientsFields,
    append: callRecipientsAppend,
    remove: callRecipientsRemove,
    update: callRecipientsUpdate,
  } = useFieldArray({
    control: generalFieldProps.control,
    name: "callRecipients",
  });
  useEffect(() => {
    if (addData) {
      addData([...escalationGroupsFields]);
    }
  }, [escalationGroupsFields]);

  const submitInfo = (data) => {
    const _groups = [...escalationGroupsFields];
    const newItem = {
      region: data.region,
      routeNo: data.routeNo,
      escalationLevel: data.escalationLevel,
      inAppRecipients: data.inAppRecipients,
      emailRecipients: data.emailRecipients,
      callRecipients: data.callRecipients,
    };
    if (currentEditing !== null) {
      _groups[currentEditing] = newItem;
      setCurrentEditing(null);
    } else {
      _groups.push(newItem);
    }
    reset({ ...escalationGroupDefault, escalationGroups: _groups });
  };

  const editCell = ({ dataItem, dataIndex }) => {
    return (
      <td>
        <Flex
          title="Edit"
          cursor="pointer"
          onClick={() => {
            reset({
              ...escalationGroupDefault,
              ...dataItem,
              escalationGroups: [...escalationGroupsFields],
            });
            setCurrentEditing(dataIndex);
          }}
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const deleteCell = ({ dataIndex }) => {
    return (
      <td>
        <Flex
          title="Delete  "
          cursor="pointer"
          onClick={() => {
            escalationGroupsRemove(dataIndex);
          }}
        >
          <MdDeleteSweep fontSize="18px" color="red" />
        </Flex>
      </td>
    );
  };

  const cancelEditing = () => {
    reset({
      ...escalationGroupDefault,
      escalationGroups: [...escalationGroupsFields],
    });
  };
  useEffect(() => {
    resetRoutes();
    const _region = watch("region");
    if (_region) {
      getRoutes(_region);
    }
  }, [watch("region")]);
  const onRegionChange = () => {
    setValue("routeNo", "");
  };
  return (
    <form onSubmit={handleSubmit(submitInfo)}>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Escalation Groups</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            gap="16px"
            onClick={() => {}}
          >
            <Button
              type="button"
              onClick={() => onPrevStep(escalationGroupsFields)}
            >
              Back
            </Button>
            <Button
              type="submit"
              onClick={() => onNextStep(escalationGroupsFields)}
            >
              Next
            </Button>
          </Flex>
        </Flex>
      </Flex>
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Region"
        name="region"
        data={regions || []}
        placeholder="Select Region"
        onChange={onRegionChange}
        rules={formValidationRules.region}
        // dropdownProps={{ filterable: true }}
      />

      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Routes"
        name="routeNo"
        data={
          routesList?.data.map((item) => ({
            value: item.routeNo,
            label: item.description,
          })) || []
        }
        placeholder="Select Route"
        dropdownProps={{ filterable: true }}
        rules={formValidationRules.routeNo}
        disabled={!watch("region")}
      />
      <NumericInput
        {...generalFieldProps}
        isRequired
        label="Escalation Level"
        name="escalationLevel"
        rules={formValidationRules.escalationLevel}
        inputProps={{ format: "#", max: 4, min: 1 }}
      />
      <div
        style={{
          width: "100%",
          fontSize: "14px",
          borderTop: `1px solid var(--primary-light)`,
          padding: "10px 0px",
          margin: 0,
        }}
      />
      <FormInput
        {...generalFieldProps}
        label="InApp Recipient"
        name="inAppRecipient"
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        {currentEditingApp !== null ? (
          <Button
            onClick={() => {
              setValue("inAppRecipient", "");
              setCurrentEditingApp(null);
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}

        <Button
          disabled={!watch("inAppRecipient")}
          onClick={() => {
            const _data = getValues("inAppRecipient");
            if (_data) {
              if (currentEditingApp === null) {
                inAppRecipientsAppend({ item: _data });
              } else {
                inAppRecipientsUpdate(currentEditingApp, { item: _data });
                setCurrentEditingApp(null);
              }
              resetField("inAppRecipient");
            }
          }}
        >
          {currentEditingApp !== null
            ? "Update App Recipient"
            : " Add App Recipient"}
        </Button>
      </div>
      <Grid data={inAppRecipientsFields}>
        <GridColumn field="item" title="InApp Recipient" />
        <GridColumn
          width={100}
          title="Edit"
          cell={({ dataItem, dataIndex }) => {
            return (
              <td>
                <Flex
                  title="Edit"
                  cursor="pointer"
                  onClick={() => {
                    setValue("inAppRecipient", dataItem.item);
                    setCurrentEditingApp(dataIndex);
                  }}
                >
                  <FaEdit fontSize="18px" color="var(--primary-dark)" />
                </Flex>
              </td>
            );
          }}
        />
        <GridColumn
          width={100}
          title="Delete"
          cell={({ dataIndex }) => (
            <td>
              <Flex
                title="Delete  "
                cursor="pointer"
                onClick={() => {
                  inAppRecipientsRemove(dataIndex);
                }}
              >
                <MdDeleteSweep fontSize="18px" color="red" />
              </Flex>
            </td>
          )}
        />
      </Grid>

      <FormInput
        {...generalFieldProps}
        label="Email Recipient"
        name="emailRecipient"
        info="abc@xyz"
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        {currentEditingEmail !== null ? (
          <Button
            onClick={() => {
              setCurrentEditingEmail(null);
              setValue("emailRecipient", "");
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button
          disabled={!watch("emailRecipient")}
          onClick={() => {
            const _data = getValues("emailRecipient");
            if (!_data || !_data.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
              setError("emailRecipient", {
                type: "custom",
                message: "Please Enter Valid Email",
              });
              return;
            }
            clearErrors("emailRecipient");
            if (currentEditingEmail === null) {
              emailRecipientsAppend({ item: _data });
            } else {
              emailRecipientsUpdate(currentEditingEmail, { item: _data });
              setCurrentEditingEmail(null);
            }
            setValue("emailRecipient", "");
          }}
        >
          {currentEditingEmail !== null
            ? " Update Email Recipient"
            : " Add Email Recipient"}
        </Button>
      </div>
      <Grid data={emailRecipientsFields}>
        <GridColumn field="item" title="Email Recipient" />
        <GridColumn
          width={100}
          title="Edit"
          cell={({ dataItem, dataIndex }) => {
            return (
              <td>
                <Flex
                  title="Edit"
                  cursor="pointer"
                  onClick={() => {
                    setValue("emailRecipient", dataItem.item);
                    setCurrentEditingEmail(dataIndex);
                  }}
                >
                  <FaEdit fontSize="18px" color="var(--primary-dark)" />
                </Flex>
              </td>
            );
          }}
        />
        <GridColumn
          width={100}
          title="Delete"
          cell={({ dataIndex }) => (
            <td>
              <Flex
                title="Delete  "
                cursor="pointer"
                onClick={() => {
                  emailRecipientsRemove(dataIndex);
                }}
              >
                <MdDeleteSweep fontSize="18px" color="red" />
              </Flex>
            </td>
          )}
        />
      </Grid>

      <FormInput
        {...generalFieldProps}
        label="Call Recipient"
        name="callRecipient"
        info="Minimum Length 10"
      />
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
          marginTop: "16px",
        }}
      >
        {currentEditingCall !== null ? (
          <Button
            onClick={() => {
              setCurrentEditingCall(null);
              setValue("callRecipient", "");
            }}
          >
            Cancel
          </Button>
        ) : (
          <></>
        )}
        <Button
          disabled={!watch("callRecipient")}
          onClick={() => {
            const _data = getValues("callRecipient");
            if (_data.length < 10) {
              setError("callRecipient", {
                type: "custom",
                message: "Please Enter Valid Number",
              });
              return;
            }
            if (currentEditingCall === null) {
              callRecipientsAppend({ item: _data });
            } else {
              callRecipientsUpdate(currentEditingCall, { item: _data });
              setCurrentEditingCall(null);
            }

            setValue("callRecipient", "");
          }}
        >
          {currentEditingCall !== null
            ? "Update Call Recipient"
            : " Add Call Recipient"}
        </Button>
      </div>
      <Grid data={callRecipientsFields}>
        <GridColumn field="item" title="Call Recipient" />
        <GridColumn
          width={100}
          title="Edit"
          cell={({ dataItem, dataIndex }) => {
            return (
              <td>
                <Flex
                  title="Edit"
                  cursor="pointer"
                  onClick={() => {
                    setValue("callRecipient", dataItem.item);
                    setCurrentEditingCall(dataIndex);
                  }}
                >
                  <FaEdit fontSize="18px" color="var(--primary-dark)" />
                </Flex>
              </td>
            );
          }}
        />
        <GridColumn
          width={100}
          title="Delete"
          cell={({ dataIndex }) => (
            <td>
              <Flex
                title="Delete"
                cursor="pointer"
                onClick={() => {
                  callRecipientsRemove(dataIndex);
                }}
              >
                <MdDeleteSweep fontSize="18px" color="red" />
              </Flex>
            </td>
          )}
        />
      </Grid>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "16px",
        }}
      >
        {currentEditing !== null ? (
          <Button onClick={cancelEditing}>Cancel</Button>
        ) : (
          <></>
        )}
        <Button type="submit">
          {currentEditing !== null ? "Update Group" : "Add Group"}
        </Button>
      </div>
      <Grid data={escalationGroupsFields}>
        <GridColumn title="Region" field="region" />
        <GridColumn title="Route" field="routeNo" />
        <GridColumn title="Escalation Level" field="escalationLevel" />
        <GridColumn
          title="In App Recipient"
          cell={({ dataItem }) => (
            <td>{dataItem.inAppRecipients.map((elm) => elm.item).join(",")}</td>
          )}
        />
        <GridColumn
          title="Email Recipient"
          cell={({ dataItem }) => (
            <td>{dataItem.emailRecipients.map((elm) => elm.item).join(",")}</td>
          )}
        />
        <GridColumn
          title="Call Recipient"
          cell={({ dataItem }) => (
            <td>{dataItem.callRecipients.map((elm) => elm.item).join(",")}</td>
          )}
        />
        <GridColumn width={100} title="Edit" cell={editCell} />
        <GridColumn width={100} title="Delete" cell={deleteCell} />
      </Grid>
    </form>
  );
}
